import { render, staticRenderFns } from "./column-header.vue?vue&type=template&id=f94019ba&lang=pug"
import script from "./column-header.vue?vue&type=script&lang=ts"
export * from "./column-header.vue?vue&type=script&lang=ts"
import style0 from "./column-header.vue?vue&type=style&index=0&id=f94019ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports